import { Component, computed, inject, OnInit, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Select, SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { InvWorkstationService } from './inv-workstation.service';
import { SelectItem } from 'app/shared/models/select-item';
import { SecurityService } from 'app/core/security/security.service';
import { UserJsVm } from 'app/shared/generated/Administration/Models/Users/UserJsVm';
import { NotificationService } from 'app/notification.service';
import { GlobalVariablesService } from 'app/services/global-variables.service';
import { BusinessAreaEnum } from 'app/core/enums/generated/BusinessAreaEnum';
import { PermissionRole } from 'app/core/enums/generated/PermissionRole';

@Component({
    selector: 'pcg-inv-workstation'
    , imports: [
        SelectModule
        , CommonModule
        , FormsModule
    ]
    , templateUrl: './inv-workstation.component.html'
    , changeDetection: ChangeDetectionStrategy.Eager
    , styleUrl: './inv-workstation.component.scss'
})
export class InvWorkstationComponent implements OnInit{

    @ViewChild('workstationSelect') workstationSelect!: Select;
    @ViewChild('inventorySelect') inventorySelect!: Select;

    invWorkstationService = inject(InvWorkstationService);
    gvs = inject(GlobalVariablesService);
    sec = inject(SecurityService);
    toastr = inject(NotificationService);
    router = inject(Router);
    route = inject(ActivatedRoute);

    user = signal<UserJsVm>(null!);
    workstation = computed(() => this.invWorkstationService.workstation());

    isSelectingWorkstation = signal<boolean>(false);
    workstationOptions = signal<SelectItem[]>([]);

    isSelectingInventory = signal<boolean>(false);
    inventoryOptions = signal<SelectItem[]>([]);
    selectedInventoryId = signal<number | null>(null);
    selectedInventory = computed(() => this.inventoryOptions().find(inv => inv.value == this.selectedInventoryId()));
    hasPerms = signal<boolean>(false);
    
    ngOnInit() {
        this.user.set(this.sec.getUser());

        this.hasPerms.set(this.sec?.hasModuleAccess(
            [BusinessAreaEnum.SysInv]
            , SecurityService.setMinRole(PermissionRole.Technician)));
        
        if (this.hasPerms()) { this.getUsersWorkstation(); }
    }

    toggleWorkstationSelecting(isShowing?: boolean) {
        const value = isShowing ?? !this.isSelectingWorkstation();

        if (value) {
            this.isSelectingWorkstation.set(value);
            this.getOptions();
            setTimeout(() => { this.workstationSelect?.show(); });
        } else {
            setTimeout(() => { this.isSelectingWorkstation.set(value); });
        }
    }

    getUsersWorkstation() {
        this.invWorkstationService.getWorkstation(this.user().invWorkstationId!)
            .subscribe(r => this.invWorkstationService.workstation.set(r));
    }

    getOptions() { this.invWorkstationService.getWorkstationOptions().subscribe(r => this.workstationOptions.set(r)); }

    setWorkstation(workstationId: number) {
        this.invWorkstationService.setWorkstation(workstationId)
            .subscribe(r => {
                this.toastr.showMessage(r.message!, r.messageClass);
                if (r.isSuccessful) { this.invWorkstationService.workstation.set(r.model); }
            }
        );
    }

    toggleInventorySelection() {
        this.isSelectingInventory.set(!this.isSelectingInventory());

        if (this.isSelectingInventory()) {
            this.invWorkstationService.getFacilityInventories(this.gvs.sysInvInventoryId()!)
                .subscribe((inventories) => {
                    this.inventoryOptions.set(inventories);
                    const selectedInventory = inventories.find(inv => inv.value == this.gvs.sysInvInventoryId());
                    this.selectedInventoryId.set(selectedInventory?.value ?? null);
                    this.inventorySelect.show();
                }
            );
        }
    }

    changeInventory(id: any) { this.router.navigate([`inv/invs/products/${id}`]); }
}
